
import * as React from 'react';
import { connect } from 'react-redux';
import { showSendContinueOnPhone } from '../../../actions/modalActions';
import { setTimeShow, handleNextStep, setStep } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import '../../FNOL/FNOL.css'
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';

class FnolStep1Sub2 extends React.Component<any, any>  {

    constructor(props) {
        super(props);
        this.state = {
            fnolStep: this.props.claimSubmit.selectedClaimStep.step,
            fnolSubStep: this.props.claimSubmit.selectedClaimStep.subStep,
            selectedCover: null,
            coverToggle: false,
            IncidentToggle: false,
            nextDisabled: true,
        };
        this.handleContinueDesktop = this.handleContinueDesktop.bind(this);
        this.handleContinueMobile = this.handleContinueMobile.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    async handleContinueDesktop(e: any) {
        await this.setState({
            continueDesktop: true,
            claimProgress: true
        })
        await this.props.dispatchHandleNextStep();
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    async handleNextStep(e: any) {
        await this.props.dispatchHandleNextStep();
        if (isMobile) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
        }
    }

    async handleContinueMobile() {
        this.props.dispatchShowSendContinueOnPhone(this.props.profile.cellphoneNumber);
    }

    public render() {
        if (!isMobile) {
            return (
                <div className="ssp-container-fnol-get-info-ready">
                    <div className="row noma">
                        <div className="col-12 nopa ssp-header-fnol-get-info-ready">
                            <h3>Get your info ready</h3>
                            <hr className="hr-minus20px" />
                            <p>
                                Tell us about your claim in just a few minutes by following our super easy claims process
                                (psst, you need to let us know within 30 days of when the incident happened)
                            </p>
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 nopa">
                            <b className="fnol-lighter-bold">Be sure to keep this super-important info on-hand:</b>
                            <ul>
                                <li>Details of the incident.</li>
                                <li>Details of the driver.</li>
                                <li>Damage to your car/motorbike.</li>
                            </ul>
                            <b className="fnol-lighter-bold">We may also ask you for this info (but it's not a train smash if you don't have it):</b>
                            <ul>
                                <li>A police report number.</li>
                                <li>Photos of the incident.</li>
                                <li>Licence disc details.</li>
                                <li>Mileage reading.</li>
                            </ul>
                            <div className="fnol-get-info-ready-please-note-box">
                                <div className="fnol-get-info-ready-please-note-header">
                                    Please note:
                                </div>
                                <div className="fnol-get-info-ready-please-note-text">
                                    If you want to take photos of your car's damage, you'll have to switch over to your phone (this isn't mandatory but it will help us process your claim faster). Tap 'Switch over to my phone' and you'll get an SMS with instructions.
                                </div>
                            </div>
                            <hr className="hr-minus20px fnol-get-info-ready-hr" />
                            <div className="fnol-get-info-ready-button-holder">
                                <button className="btn btn-solid-red infoready-btn" onClick={this.handleContinueDesktop}>Continue on desktop</button>
                                <button className="btn btn-outline-red infoready-btn" onClick={this.handleContinueMobile}>Switch over to my phone</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="fnol-mobile-view ssp-container-fnol-get-info-ready">
                    <div className="row noma">
                        <div className="col-12 nopa ssp-header-fnol-get-info-ready">
                            <h3>Get your info ready</h3>
                            <hr className="hr-minus20px" />
                            <p>
                                Register your claim within 30 days of when the incident occurred and follow our easy claim process,
                                it should only take a couple of minutes.
                            </p>
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 nopa">
                            <b className="fnol-lighter-bold">Be sure to keep this super-important info on-hand:</b>
                            <ul>
                                <li>Details of the incident.</li>
                                <li>Details of the driver.</li>
                                <li>Damage to your car/motorbike.</li>
                            </ul>
                            <b className="fnol-lighter-bold">We may also ask you for this info (but it's not a train smash if you don't have it):</b>
                            <ul>
                                <li>A police report number.</li>
                                <li>Photos of the incident.</li>
                                <li>Licence disc details.</li>
                                <li>Mileage reading.</li>
                            </ul>
                            <div className="fnol-get-info-ready-button-holder-single">
                                <button className="btn btn-solid-red" onClick={this.handleNextStep}>Begin</button>
                            </div>
                        </div>
                    </div>
            </div>)
        }
    }
}


const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchShowSendContinueOnPhone: (phoneNumber) => dispatch(showSendContinueOnPhone(phoneNumber)),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep1Sub2)